import React from 'react';
import { connect } from 'react-redux';
import { AUTHENTICATOR_ALGORITHM } from '../../../constants';
import { trans } from '../../../localization/language';
import Success from '../../Success';

class DoneRevokeAuthenticator extends React.Component {
	render() {
		var title = trans('revoke_authenticator_title');
		if (this.props.userInfo.authenticator_algorithm === AUTHENTICATOR_ALGORITHM.GOOGLE) {
			title = trans('revoke_google_authenticator_title');
		}
		var message = trans('revoke_authenticator_success');
		return (
			<Success title={title} message={message} />
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo
	}
}

export default connect(mapStateToProps)(DoneRevokeAuthenticator);



// WEBPACK FOOTER //
// ./app/components/security/authenticator/DoneRevokeAuthenticator.js